// extracted by mini-css-extract-plugin
export default {"card":"sO_PrCO4u3WNJ5gZbzGo","breakdownContent":"JFOH_OXvRe7znDM6MaK3"};